import React, {useState} from 'react';
import {Button, Tooltip} from '@material-ui/core';
import {useNavigate} from 'react-router-dom';

import DesktopWindowsIcon from '@material-ui/icons/DesktopWindows';
import AdminPanelSettingsOutlinedIcon from '@mui/icons-material/AdminPanelSettingsOutlined';

interface ActiveProps {
    isActiveNavElem: string;
    setActiveNavElem: React.Dispatch<React.SetStateAction<string>>;
    isAdmin: boolean;
    isSuperAdmin?: boolean;
}

const NavPanel = (props: ActiveProps): React.JSX.Element => {
    const {isActiveNavElem, setActiveNavElem, isAdmin, isSuperAdmin} = props;
    const navigate = useNavigate();

    const [isOpen, changeNav] = useState(false);

    const handleClick = (e: React.MouseEvent) => {
        if (e.currentTarget.id === 'admin') {
            navigate('/admin');
            setActiveNavElem('admin');
        }
        if (e.currentTarget.id === 'userDesk') {
            navigate('/home');
            setActiveNavElem('home');
        }
        if (e.currentTarget.id === 'kkmControl') {
            navigate('/kkm-control');
            setActiveNavElem('kkmControl');
        }
        if (e.currentTarget.id === 'nomenklatura') {
            navigate('/nomenklatura');
            setActiveNavElem('nomenklatura');
        }
        if (e.currentTarget.id === 'payment') {
            navigate('/payment');
            setActiveNavElem('payment');
        }
    };

    const handleClickLogo = (e: React.MouseEvent) => {
        if (isSuperAdmin) {
            setActiveNavElem('admin');
            navigate('/admin');
        } else if (isAdmin) {
            setActiveNavElem('deskControl');
            navigate('/kkm-control');
        } else {
            setActiveNavElem('home');
            navigate('/home');
        }
    };

    return (
        <nav className={`nav-panel ${isOpen ? 'open' : ' '}`}>
            <div className={'top'}>
                <div className={'block-top'}>
                    <div className={'left'} />
                    <div className={'logo'} onClick={handleClickLogo}>
                        <svg viewBox="0 0 65 65" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g opacity="0.4" filter="url(#filter0_f_257_2404)">
                                <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M16.0664 48.1964C16.0664 48.1964 15.7544 41.0114 19.9935 36.7723C24.2326 32.5331 31.4176 32.8452 31.4176 32.8452C31.4176 32.8452 31.7297 40.0302 27.4906 44.2694C23.2515 48.5085 16.0664 48.1964 16.0664 48.1964ZM32.8455 31.4171C32.8455 31.4171 32.5334 24.232 36.7726 19.9929C41.0117 15.7538 48.1967 16.0659 48.1967 16.0659C48.1967 16.0659 48.5088 23.2509 44.2697 27.49C40.0305 31.7291 32.8455 31.4171 32.8455 31.4171ZM31.4161 31.4172C31.4161 31.4172 24.231 31.7293 19.9919 27.4902C15.7528 23.251 16.0649 16.066 16.0649 16.066C16.0649 16.066 23.2499 15.7539 27.489 19.9931C31.7281 24.2322 31.4161 31.4172 31.4161 31.4172ZM48.1951 48.1964C48.1951 48.1964 41.0101 48.5085 36.771 44.2694C32.5318 40.0303 32.8439 32.8452 32.8439 32.8452C32.8439 32.8452 40.0289 32.5332 44.2681 36.7723C48.5072 41.0114 48.1951 48.1964 48.1951 48.1964Z"
                                    fill="url(#paint0_linear_257_2404)"
                                />
                            </g>
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M16.0665 48.1964C16.0665 48.1964 15.7544 41.0114 19.9935 36.7722C24.2326 32.5331 31.4177 32.8452 31.4177 32.8452C31.4177 32.8452 31.7297 40.0302 27.4906 44.2693C23.2515 48.5085 16.0665 48.1964 16.0665 48.1964ZM32.8456 31.4171C32.8456 31.4171 32.5335 24.2321 36.7726 19.993C41.0117 15.7538 48.1968 16.0659 48.1968 16.0659C48.1968 16.0659 48.5088 23.2509 44.2697 27.4901C40.0306 31.7292 32.8456 31.4171 32.8456 31.4171ZM31.4161 31.4172C31.4161 31.4172 24.231 31.7293 19.9919 27.4902C15.7528 23.251 16.0649 16.066 16.0649 16.066C16.0649 16.066 23.2499 15.7539 27.489 19.9931C31.7281 24.2322 31.4161 31.4172 31.4161 31.4172ZM48.1951 48.1964C48.1951 48.1964 41.0101 48.5085 36.771 44.2694C32.5318 40.0303 32.8439 32.8452 32.8439 32.8452C32.8439 32.8452 40.0289 32.5332 44.2681 36.7723C48.5072 41.0114 48.1951 48.1964 48.1951 48.1964Z"
                                fill="url(#paint1_linear_257_2404)"
                            />
                            <defs>
                                <filter
                                    id="filter0_f_257_2404"
                                    x="2.06055"
                                    y="2.06073"
                                    width="60.1406"
                                    height="60.1408"
                                    filterUnits="userSpaceOnUse"
                                    colorInterpolationFilters="sRGB"
                                >
                                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                                    <feGaussianBlur stdDeviation="7" result="effect1_foregroundBlur_257_2404" />
                                </filter>
                                <linearGradient
                                    id="paint0_linear_257_2404"
                                    x1="47.2509"
                                    y1="54.711"
                                    x2="17.4085"
                                    y2="12.4343"
                                    gradientUnits="userSpaceOnUse"
                                >
                                    <stop stopColor="#008AEE" />
                                    <stop offset="1" stopColor="#9DE7FF" />
                                </linearGradient>
                                <linearGradient
                                    id="paint1_linear_257_2404"
                                    x1="32.1309"
                                    y1="1.52588e-05"
                                    x2="0.000438567"
                                    y2="32.1304"
                                    gradientUnits="userSpaceOnUse"
                                >
                                    <stop stopColor="#27BEFF" />
                                    <stop offset="1" stopColor="#0063FF" />
                                </linearGradient>
                            </defs>
                        </svg>
                    </div>
                    <div className={'right'}>
                        {isOpen && (
                            <Button onClick={() => changeNav(!isOpen)}>
                                <svg className={'icon'} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9 8L5 12L9 16" stroke="#33415B" strokeWidth="2" strokeLinecap="round" />
                                    <rect x="15" y="4" width="3" height="16" rx="1" stroke="#33415B" strokeWidth="2" strokeLinecap="round" />
                                </svg>
                            </Button>
                        )}
                    </div>
                </div>
                <div className={'block-bottom'}>
                    {!isOpen && (
                        <Button onClick={() => changeNav(!isOpen)}>
                            <svg className={'icon'} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10 8L14 12L10 16" stroke="#33415B" strokeWidth="2" strokeLinecap="round" />
                                <rect x="4" y="4" width="16" height="16" rx="1" stroke="#33415B" strokeWidth="2" strokeLinecap="round" />
                            </svg>
                        </Button>
                    )}
                </div>
            </div>
            <hr className={'line'} />
            {isSuperAdmin && (
                <Tooltip id={`nav-button${!isOpen ? '' : '-hidden'}`} title="Админка" arrow placement="bottom">
                    <Button id="admin" className={`btn ${isActiveNavElem === 'kkmControl' ? 'active' : ''}`} onClick={handleClick}>
                        <AdminPanelSettingsOutlinedIcon className='icon' />
                        <p>Админка</p>
                    </Button>
                </Tooltip>
            )}
            {isAdmin ? (
                <Tooltip id={`nav-button${!isOpen ? '' : '-hidden'}`} title="Клиенты и кассы" arrow placement="bottom">
                    <Button id="kkmControl" className={`btn ${isActiveNavElem === 'kkmControl' ? 'active' : ''}`} onClick={handleClick}>
                        <svg className={'icon'} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M19.9695 13.9055C20.0424 14.1094 19.9809 14.3368 19.8236 14.4821L18.8366 15.4057C18.8617 15.6003 18.8754 15.7996 18.8754 16.0012C18.8754 16.2028 18.8617 16.402 18.8366 16.5966L19.8236 17.5202C19.9809 17.6656 20.0424 17.8929 19.9695 18.0969C19.8692 18.3759 19.7484 18.6431 19.6094 18.901L19.5022 19.0908C19.3518 19.3487 19.1831 19.5925 18.9985 19.8222C18.864 19.991 18.6406 20.0473 18.44 19.9816L17.1704 19.5667C16.8649 19.8082 16.5276 20.0098 16.1674 20.1621L15.8825 21.5007C15.8369 21.714 15.6773 21.8828 15.4676 21.918C15.1531 21.9719 14.8294 22 14.4989 22C14.1683 22 13.8447 21.9719 13.5301 21.918C13.3204 21.8828 13.1608 21.714 13.1152 21.5007L12.8303 20.1621C12.4702 20.0098 12.1328 19.8082 11.8274 19.5667L10.56 19.984C10.3594 20.0496 10.136 19.991 10.0015 19.8246C9.8169 19.5948 9.64822 19.351 9.49778 19.0932L9.39064 18.9033C9.2516 18.6454 9.13079 18.3782 9.03049 18.0992C8.95755 17.8953 9.0191 17.6679 9.17638 17.5226L10.1634 16.5989C10.1383 16.402 10.1246 16.2028 10.1246 16.0012C10.1246 15.7996 10.1383 15.6003 10.1634 15.4057L9.17638 14.4821C9.0191 14.3368 8.95755 14.1094 9.03049 13.9055C9.13079 13.6265 9.2516 13.3592 9.39064 13.1014L9.49778 12.9115C9.64822 12.6536 9.8169 12.4098 10.0015 12.1801C10.136 12.0113 10.3594 11.9551 10.56 12.0207L11.8296 12.4356C12.1351 12.1942 12.4724 11.9926 12.8326 11.8402L13.1175 10.5017C13.1631 10.2883 13.3227 10.1196 13.5324 10.0844C13.8469 10.0281 14.1706 10 14.5011 10C14.8317 10 15.1553 10.0281 15.4699 10.082C15.6796 10.1172 15.8392 10.286 15.8848 10.4993L16.1697 11.8379C16.5298 11.9902 16.8672 12.1918 17.1726 12.4333L18.4423 12.0184C18.6429 11.9527 18.8663 12.0113 19.0007 12.1778C19.1854 12.4075 19.3541 12.6513 19.5045 12.9092L19.6116 13.099C19.7507 13.3569 19.8715 13.6241 19.9718 13.9031L19.9695 13.9055ZM14.5011 17.8765C15.5087 17.8765 16.3247 17.0373 16.3247 16.0012C16.3247 14.965 15.5087 14.1258 14.5011 14.1258C13.4936 14.1258 12.6776 14.965 12.6776 16.0012C12.6776 17.0373 13.4936 17.8765 14.5011 17.8765Z"
                                fill="#33415B"
                            />
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M5 3C3.89543 3 3 3.89543 3 5V15C3 16.1046 3.89543 17 5 17H8.07089C8.02417 16.6734 8 16.3395 8 16C8 15.6605 8.02417 15.3266 8.07089 15H5V5L15 5V9C15.695 9 16.3663 9.10128 17 9.28988V5C17 3.89543 16.1046 3 15 3H5Z"
                                fill="#33415B"
                            />
                        </svg>
                        <p>Клиенты и кассы</p>
                    </Button>
                </Tooltip>
            ) : (
                <Tooltip id={`nav-button${!isOpen ? '' : '-hidden'}`} title="Состояние касс" arrow placement="bottom">
                    <Button id="userDesk" className={`btn ${isActiveNavElem === 'userDesk' ? 'active' : ''}`} onClick={handleClick}>
                        <DesktopWindowsIcon className={'navImg'} />
                        <p className={'text'}>Состояние касс</p>
                    </Button>
                </Tooltip>
            )}
            <Tooltip id={`nav-button${!isOpen ? '' : '-hidden'}`} title="Номенклатура" arrow placement="bottom">
                <Button id="nomenklatura" className={`btn ${isActiveNavElem === 'nomenklatura' ? 'active' : ''}`} onClick={handleClick}>
                    <svg className={'icon'} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="4" y="3" width="11" height="13" rx="1" stroke="#33415B" strokeWidth="2" strokeLinecap="round" />
                        <rect x="7" y="6" width="5" height="2" rx="0.5" fill="#33415B" />
                        <rect x="7" y="6" width="5" height="2" rx="0.5" fill="#33415B" />
                        <rect x="7" y="10" width="3" height="2" rx="0.5" fill="#33415B" />
                        <rect x="7" y="10" width="3" height="2" rx="0.5" fill="#33415B" />
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M7 18V19C7 20.1046 7.89543 21 9 21H18C19.1046 21 20 20.1046 20 19V8C20 6.89543 19.1046 6 18 6H17V8H18V19H9V18H7Z"
                            fill="#33415B"
                        />
                    </svg>
                    <p>Номенклатура</p>
                </Button>
            </Tooltip>
            {isAdmin ? (
                <Tooltip id={`nav-button${!isOpen ? '' : '-hidden'}`} title="Оплатить" arrow placement="bottom">
                    <Button id="payment" className={`btn ${isActiveNavElem === 'payment' ? 'active' : ''}`} onClick={handleClick}>
                        <svg className={'icon'} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M18.4 8.11111V6.55556C18.4 5.69767 17.6824 5 16.8 5H6.4C5.0768 5 4 6.04689 4 7.33333V16.6667C4 18.3786 5.4352 19 6.4 19H18.4C19.2824 19 20 18.3023 20 17.4444V9.66667C20 8.80878 19.2824 8.11111 18.4 8.11111ZM6.4 6.55556H16.8V8.11111H6.4C6.19402 8.10215 5.99952 8.01629 5.85702 7.87141C5.71452 7.72653 5.63499 7.5338 5.63499 7.33333C5.63499 7.13287 5.71452 6.94013 5.85702 6.79525C5.99952 6.65037 6.19402 6.56451 6.4 6.55556ZM18.4 17.4444H6.4096C6.04 17.4351 5.6 17.2928 5.6 16.6667V9.52278C5.8512 9.61067 6.1176 9.66667 6.4 9.66667H18.4V17.4444Z"
                                fill="#33415B"
                            />
                            <circle cx="16" cy="14" r="1" fill="#33415B" />
                        </svg>
                        <p>Оплатить</p>
                    </Button>
                </Tooltip>
            ) : (
                <></>
            )}
        </nav>
    );
};

export default NavPanel;
